import Vue from 'vue';
import Router from 'vue-router';


Vue.use(Router);

const routes = [
    //////// 平台首页 ////////////////////////////////////////////////
    {
      path: '/',
      name:"website",
      component: () => import('./view/website/imgzo_index'),
      meta: {
          title: 'imgzo.cn 互联网+影像平台',
          showTabbar: false
      }, 
    },
    {
      path: '/index',
      name:"imgzoIndex",
      component: () => import('./view/website/imgzo_index'),
      meta: {
          title: 'imgzo.cn 互联网+影像平台',
          showTabbar: false
      }, 
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./view/login/login'),
        meta: {
            title: 'imgzo.cn 互联网+影像平台－系统登录',
            showTabbar: false   //是否显示底部导航栏
        }, 
    },
    // {
    //     path: '/login',
    //     name: 'login',
    //     component: () => import('./view/login/login'),
    //     meta: {
    //         title: 'imgzo.cn 互联网+影像平台－系统登录',
    //         showTabbar: false   //是否显示底部导航栏
    //     }, 
    // }
];

routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
      document.title = title;
    }
    next();
  });
  
export {
    router
};
